<template>
    <section class="o-bk-box box-sh bg-white is-rounded mt-4">
        <div class="o-bk-box__title d-flex align-items-center">
            <span :class="icon" class="is-square-icon is-rounded bg-sec-light-hover cl-sec-l"></span>
            <h3 class="c-ttl c-ttl--mdp ml-3">{{ supplement.name }} <span
                class="cl-sec-l fw-r ml-1 fs-16">{{ currency(price) }} each</span></h3>
        </div>

        <div class="cl-dark">
            <!--p class="p-3 mt-3 mb-4 is-rounded bg-suc cl-sec">
                Completa le informazioni del passeggero come indicati sui documenti di viaggio
                che utilizzerai.
            </p-->

            <p class="my-4 fs-14 lh-xl">
                <info-icon />
                <span v-html="supplement.description"></span>
            </p>

            <div class="supplement-items" v-if="supplementItems.length">
                <div class="o-bk-form-row" v-for="supplementItem in supplementItems" v-bind:key="supplementItem.passenger">
                    <div class="o-bk-form-row__item" :class="{
                        'is-md': supplement.limit != 1,
                        'is-2md': supplement.limit == 1,    
                    }">
                        <div class="form-group">
                            <label class="mb-1 fw-r d-block">Passenger</label>

                            <input class="form-control" :value="getPassengerName(supplementItem.passenger)" disabled>
                        </div>
                    </div>

                    <div class="o-bk-form-row__item is-md" v-if="supplement.limit != 1">
                        <div class="form-group">
                            <label class="mb-1 fw-r d-block">Quantity</label>

                            <select
                                class="form-control custom-select"
                                :value="supplementItem.quantity"
                                @change="updateSupplementQuantity(supplementItem.passenger, $event.target.value)">
                                <option :value="i" v-for="i in 3" v-bind:key="i">{{ i }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="o-bk-form-row__item is-md">
                        <div class="form-group text-right">
                            <label class="mb-1 fw-r d-none d-md-block">&nbsp;</label>
                            <button
                                class="btn btn-white-alt-sec-l is-smaller bg-white txt-init"
                                name="remove-supplement"
                                type="button"
                                @click="removeSupplement(supplementItem.passenger)">
                                Remove supplement
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <form class="o-bk-form-row" @submit="addSupplement">
                <div class="o-bk-form-row__item"
                    :class="{
                        'is-md': supplement.limit != 1,
                        'is-2md': supplement.limit == 1,
                    }">
                    <div class="form-group">
                        <label class="mb-1 fw-r d-block">Select passenger</label>

                        <select class="form-control custom-select" required v-model="addForm.passenger">
                            <option></option>
                            <option
                                v-for="option in passengerOptions"
                                v-bind:key="option.key"
                                :disabled="option.disabled"
                                :value="option.key"
                            >{{ option.label }}</option>
                        </select>
                    </div>
                </div>

                <div class="o-bk-form-row__item is-md" v-if="supplement.limit != 1">
                    <div class="form-group">
                        <label class="mb-1 fw-r d-block">Quantity</label>

                        <select class="form-control custom-select" required v-model="addForm.quantity">
                            <option :value="i" v-for="i in 3" v-bind:key="i">{{ i }}</option>
                        </select>
                    </div>
                </div>

                <div class="o-bk-form-row__item is-md">
                    <div class="form-group text-right">
                        <label class="mb-1 fw-r d-none d-md-block">&nbsp;</label>
                        <button class="btn btn-white-alt-sec-l is-smaller bg-white txt-init" type="submit">Add {{ supplement.name }}</button>
                    </div>
                </div>
            </form>
        </div>
    </section>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import InfoIcon from '../components/InfoIcon.vue'
export default {
  components: { InfoIcon },
    props: {
        supplement: Object,
    },
    data() {
        const icons = {
            BC: 'icon-bike',
            PT: 'icon-pet',
        }
        return {
            icon: icons[this.supplement.code],
            addForm: {
                passenger: null,
                quantity: null,
            },
        }
    },
    computed: {
        ...mapState('booking', [
            'passengers',
            'supplements',
            'prices',
        ]),
        passengerOptions() {
            return this.passengers.filter(passenger => passenger.category != 'inf').map((passenger, index) => {
                return {
                    key: index,
                    label: passenger.name+' '+passenger.surname,
                    disabled: this.supplements.find(supplement => (supplement.passenger == index && supplement.id == this.supplement.id)),
                }
            })
        },
        supplementItems() {
            return this.supplements.filter(supplement => supplement.id == this.supplement.id)
        },
        price() {
            let supplementPrices = this.prices.supplements.find(supplementPrice => supplementPrice.supplement.id == this.supplement.id)
            return supplementPrices ? Object.values(supplementPrices.price).reduce((a, b) => a + parseFloat(b), 0) : 0
        }
    },
    methods: {
        ...mapActions('booking', [
            'getQuote',
        ]),
        ...mapMutations('booking', [
            'setTransfer'
        ]),
        getPassengerName(passengerIndex) {
            let passenger = this.passengers[passengerIndex]
            return passenger.name+' '+passenger.surname
        },
        addSupplement(e) {
            e.preventDefault()
            this.$store.commit('booking/addSupplement', {
                passenger: parseInt(this.addForm.passenger),
                supplement: parseInt(this.supplement.id),
                quantity: parseInt(this.addForm.quantity),
            })
            this.addForm.passenger = null
            this.addForm.quantity = null
            if (!this.supplement.transfers) {
                this.setTransfer(null)
            }
            this.getQuote()

            this.track({
                event: 'add_supplement'
            })
        },
        updateSupplementQuantity(passenger, quantity) {
            this.$store.commit('booking/updateSupplementQuantity', {
                passenger: parseInt(passenger),
                supplement: parseInt(this.supplement.id),
                quantity: parseInt(quantity),
            })
            this.getQuote()
        },
        removeSupplement(passenger) {
            this.$store.commit('booking/removeSupplement', {
                supplement: parseInt(this.supplement.id),
                passenger: parseInt(passenger)
            })
            this.getQuote()

            this.track({
                event: 'remove_supplement'
            })
        },
    }
}
</script>